import DotPattern from "@/components/dot-pattern";
import DilemmaForm from "@/features/dilemmas/components/forms/dilemma-form";
import { useFetchDilemma } from "@/features/dilemmas/hooks/useFetchDilemma";
import { useDilemmasFormStore } from "@/features/dilemmas/stores/useDilemmaFormStore";
import { Skeleton } from "@/components/ui/skeleton";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDynamicPageTitle } from "@/hooks";
import { useSetAtom } from "jotai";
import { navActiveOverrideAtom } from "@/stores/atoms/nav-active-override-atom";
import { pageTitleIsAiGeneratedAtom } from "@/stores/atoms/page-title-ai-atom";
import { ROUTES } from "@/constants/routes";

const DilemmaEditPage = () => {
  const { id } = useParams();
  const { dilemma, isLoading } = useFetchDilemma(id);
  useDynamicPageTitle(dilemma ? `${dilemma.reference}` : "");
  const initFromApi = useDilemmasFormStore((s) => s.initFromApi);
  const reset = useDilemmasFormStore((s) => s.reset);
  const initialDilemma = useDilemmasFormStore((s) => s.initialDilemma);
  const setNavOverride = useSetAtom(navActiveOverrideAtom);
  const setIsAiGenerated = useSetAtom(pageTitleIsAiGeneratedAtom);

  useEffect(() => {
    if (!dilemma) return;
    initFromApi(dilemma);
    return () => reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dilemma?.id]);

  useEffect(() => {
    if (dilemma?.source === "mobile") {
      setNavOverride(ROUTES.SUBMISSIONS);
    }
    return () => setNavOverride(null);
  }, [dilemma, setNavOverride]);

  useEffect(() => {
    setIsAiGenerated(!!dilemma?.is_ai_generated);
    return () => setIsAiGenerated(false);
  }, [dilemma?.is_ai_generated, setIsAiGenerated]);

  return (
    <div className="relative flex flex-col lg:flex-row gap-3 lg:gap-5 p-3 lg:p-6">
      <DotPattern />
      {isLoading && (
        <div className="flex flex-col lg:flex-row gap-3 lg:gap-5 w-full">
          <Skeleton className="w-full lg:w-56 h-48" />
          <Skeleton className="flex-1 h-96" />
        </div>
      )}
      {dilemma && !isLoading && initialDilemma?.id === dilemma.id && (
        <DilemmaForm editMode />
      )}
    </div>
  );
};

export default DilemmaEditPage;
